/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faDatabase} from '@fortawesome/pro-duotone-svg-icons';

const DataIntegrationsIcon = ({icon, ...props}) => (
  <FontAwesomeIcon icon={faDatabase} {...props} />
);

export default DataIntegrationsIcon;
